import _get from "lodash/get"
import { sumOfValuesInObjectProperties } from "./sumOfValuesInObjectProperties"
import _includes from "lodash/includes"

export function sendGtmEventError(errorType, errorMessage) {
  const data = {
    event: "error",
    error_type: errorType,
    error_message: errorMessage
  }

  sendGtm(data)
}

export function sendGtmEventFormSubmit(formType) {
  const data = {
    event: "form_submit",
    form_typ: formType
  }

  sendGtm(data)
}

export function sendGtmEventFileDownload(label) {
  const data = {
    event: "file_download",
    category: "interacao_usuario",
    action: "baixou_arquivo",
    label
  }

  sendGtm(data)
}

export function sendGtmEventClick() {
  const validElements = ["BUTTON", "A"]

  document.body.addEventListener("click", (event) => {
    if (_includes(validElements, event.target.nodeName)) {
      if (_includes(event.target.href, "blob")) return

      const data = {
        event: "gtm.click",
        elementLink: event.target.href || "",
        elementId: event.target.id,
        elementText: event.target.innerText
      }

      sendGtm(data)
    }
  })
}

export function sendGtmEventPageView() {
  const customerStorage = window.localStorage.getItem("customerData")
  if (!customerStorage) return

  const customer = JSON.parse(customerStorage)

  const data = {
    event: "page_view",
    segment: _get(customer, ["customerSegment"], ""),
    user_id: _get(customer, ["customerId"], "")
  }

  sendGtm(data)
}

export function sendGtmEventRegistrationData(label) {
  if (!label) return

  const data = {
    event: "alteracao_dados_empresa",
    interacao_usuario: {
      category: "gestao_empresa",
      action: "alterou_dados",
      label
    }
  }

  sendGtm(data)
}

export function sendGtmEventSuport(eventData) {
  if (!eventData) return

  const data = {
    event: "solicitar_suporte",
    interacao_usuario: {
      category: "suporte_cliente",
      action: "abriu_chamado",
      label: _get(eventData, ["product"], ""),
      descricao_problema: _get(eventData, ["message"], ""),
      urgencia: ""
    }
  }

  sendGtm(data)
}

export function sendGtmUserData() {
  const customer = JSON.parse(window.localStorage.getItem("customerData"))
  if (!customer) return

  const data = {
    event: "user_data",
    user_id: _get(customer, ["customerId"], ""),
    segment: _get(customer, ["customerSegment"], "")
  }

  sendGtm(data)
}

export function sendGtmPurchase() {
  const data = {
    event: "compra_vox_fixa",
    ecommerce: {
      transaction_id: "",
      affiliation: "Portal do Usuário Corporativo",
      value: "",
      currency: "",
      payment_method: "",
      items: []
    }
  }

  sendGtm(data)
}

export function sendGtmNegotiation(data) {
  if (!data) return

  const gtmData = {
    event: "negociar_fatura",
    interacao_usuario: {
      category: "financeiro",
      action: "solicitou_negociacao",
      label: "Fatura Mensal",
      valor_original: sumOfValuesInObjectProperties(
        _get(data, ["selectedInvoices"], ""),
        "amount"
      ),
      valor_negociado: _get(data, ["parcelingData", "amount"], ""),
      parcelas: _get(data, ["parcelingData", "numberOfInstallment"], ""),
      meio_pagamento: "boleto"
    }
  }

  sendGtm(gtmData)
}

export function sendGtm(data) {
  if (!window.dataLayer) return
  window.dataLayer.push(data)
}

export function sendGtmCancellation(data) {
  if (!data) return

  const gtmData = {
    event: "cancelamento_servico",
    interacao_usuario: {
      category: _get(data, "category", ""),
      action: "cancelou_servico",
      label: _get(data, "label", ""),
      motivo: _get(data, "motivo", ""),
      descricao: _get(data, "description", ""),
      matriz_empresa: "Soluções Algar - Matriz 198",
      id_contrato: _get(data, "id_contrato", "")
    }
  }

  sendGtm(gtmData)
}



// WEBPACK FOOTER //
// ./src/services/utils/sendGtm.js